<template>
  <nav class="navbar navbar-expand navbar-light topbar static-top">
    <div class="sidebar sidebar-dark">
      <a
        class="sidebar-brand d-flex align-items-center justify-content-center"
        href="/home"
      >BMORadio</a>
    </div>
    <!-- Topbar Navbar -->
    <ul class="navbar-nav mr-auto">
      <li class="nav-item" :class="{'active' : item.is_active}" v-for="item in menuItems" :key="item.id">
        <a v-if="item.roles.includes(user.userRole) || item.roles.includes('*')" class="nav-link" @click="redirectTo(item.url)">
          <i class="fas" :class="item.icon" />
          <span>{{ item.label }}</span>
        </a>
      </li>
    </ul>
    <ul class="navbar-nav ml-auto">
      <li class="nav-item">
        <a class="nav-link nav-user-role text-center" @click="redirectTo('/users/'+ user.userId +'/edit')">
          <span class="user">{{user.userName}}</span>
          <small class="role">({{user.userRole}})</small>

        </a>
      </li>
      <li class="nav-item">
        <a
            class="nav-link"
            v-on:click="logout($event)"
            href="#"
            data-toggle="modal"
            data-target="#logoutModal"
        >
        <i class="fas fa-sign-out-alt fa-sm fa-fw text-gray-400"></i>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import router from '@/router';
import store from '@/store/index';

export default {
  name: 'main-menu',
  data() {
    return {
      user: {},
    };
  },
  mounted() {
    this.user = store.state.user
  },
  computed: {
    menuItems() {
      return [
        {
          id: 1,
          is_active: this.$route.meta.MenuItem === 1,
          icon: 'fa-file-invoice',
          label: 'Orders',
          url: '/home',
          roles: ['*'],          
        },
        // {
        //   id: 2,
        //   is_active: this.$route.meta.MenuItem === 2,
        //   icon: 'fa-file-invoice',
        //   label: 'Returned Orders',
        //   url: '/returned-orders'
        // },
        // {
        //   id: 3,
        //   is_active: this.$route.meta.MenuItem === 3,
        //   icon: 'fa-box',
        //   label: 'Products',
        //   url: '/products'
        // },
        // {
        //   id: 4,
        //   is_active: this.$route.meta.MenuItem === 4,
        //   icon: 'fa-id-card',
        //   label: 'Customers',
        //   url: '/customers',
        // },
        {
          id: 5,
          is_active: this.$route.meta.MenuItem === 5,
          icon: 'fa-box',
          label: 'Internal Products',
          url: '/internal-products',
          roles: ['*'],
        },
        {
          id: 6,
          is_active: this.$route.meta.MenuItem === 6,
          icon: 'fa-align-justify',
          label: 'Series',
          url: '/series',
          roles: ['*'],
        },
        {
          id: 7,
          is_active: this.$route.meta.MenuItem === 7,
          icon: 'fa-server',
          label: 'Domains',
          url: '/domains',
          roles: ['*'],
        },     
        {
          id: 8,
          is_active: this.$route.meta.MenuItem === 8,
          icon: 'fa-user',
          label: 'Users',
          url: '/users',
          roles: ['Admin','Developer'],
        },   
        {
          id: 9,
          is_active: this.$route.meta.MenuItem === 9,
          icon: 'fa-history',
          label: 'Actions',
          url: '/actions',
          roles: ['Admin','Developer'],
        },
/*
        {
          id: 99,
          is_active: this.$route.meta.MenuItem === 99,
          icon: 'fa-server',
          label: 'Internal Products V2',
          url: '/internal-products-v2/12/edit',
        },
*/
      ]
    }
  },
  methods: {
    redirectTo(url) {
      if (url != '/users/undefined/edit') {
        router.push(url);
      }      
    },
    logout(event) {
      event.preventDefault();
      localStorage.clear();
      router.push('/login');
    }
  },
};
</script>
